/* 
 * Export component file to be used on project
*/

import Tooltip from './Tooltip';
export default Tooltip;